module.exports = __webpack_public_path__ + "img/logo.e0cc01c3.svg";